<script lang="ts">
    import {
        similarPhrasesUpdateActiveItemBackward,
        similarPhrasesUpdateActiveItemForward,
        wordlistUpdateActiveItem,
    } from "../Search.store";
    import {
        similarPhrasesSelectActiveItem,
        wordlistSelectActiveItem,
    } from "../SearchService";

    export let dictionarySearchInput: HTMLInputElement;

    if (dictionarySearchInput) {
        const sidebarWordlistContainer =
            document.getElementById("sidebar-wordlist");
        //if (!sidebarWordlistContainer) {
            dictionarySearchInput.addEventListener(
                "keydown",
                (event: KeyboardEvent) => {
                    if (event.key === "ArrowDown") {
                        similarPhrasesUpdateActiveItemForward();
                    }
                    if (event.key === "ArrowUp") {
                        similarPhrasesUpdateActiveItemBackward();
                    }

                    if (event.key === "Enter") {
                        similarPhrasesSelectActiveItem(event);
                    }
                }
            );
            /*
        } else {
            // there is a wordlist (we are on phrase translation page)
            dictionarySearchInput.addEventListener(
                "keydown",
                (event: KeyboardEvent) => {
                    if (event.key === "ArrowDown") {
                        wordlistUpdateActiveItem(1);
                    }
                    if (event.key === "ArrowUp") {
                        wordlistUpdateActiveItem(-1);
                    }

                    if (event.key === "Enter") {
                        wordlistSelectActiveItem(event);
                    }
                }
            );
        }*/
    }
</script>
